import {
  ACCESS_POINTS_LIST_FAILURE,
  ACCESS_POINTS_LIST_REQUESTED,
  ACCESS_POINTS_LIST_SUCCEEDED,
  ACCESS_POINT_CREATE_FAILURE,
  ACCESS_POINT_CREATE_REQUESTED,
  ACCESS_POINT_CREATE_SUCCEEDED,
  ACCESS_POINT_UPDATE_FAILURE,
  ACCESS_POINT_UPDATE_REQUESTED,
  ACCESS_POINT_UPDATE_SUCCEEDED,
  DOORS_REORDER_FAILURE,
  DOORS_REORDER_REQUEST,
  DOORS_REORDER_SUCCESS,
  DOOR_CREATE_FAILURE,
  DOOR_CREATE_REQUESTED,
  DOOR_CREATE_SUCCEEDED,
  DOOR_DELETE_FAILURE,
  DOOR_DELETE_REQUEST,
  DOOR_DELETE_SUCCESS,
  DOOR_UPDATE_FAILURE,
  DOOR_UPDATE_REQUESTED,
  DOOR_UPDATE_SUCCEEDED,
  GET_AP_DEVICE_MODELS_FAILURE,
  GET_AP_DEVICE_MODELS_REQUEST,
  GET_AP_DEVICE_MODELS_SUCCESS,
  GET_DOORS_FAILURE,
  GET_DOORS_REQUEST,
  GET_DOORS_SUCCESS,
  GET_DOOR_FAILURE,
  GET_DOOR_REQUEST,
  GET_DOOR_SUCCESS,
  GET_ITEMS_FOR_EXPORT_SUCCESS,
  ON_DOOR_SCHEDULE_CHANGE_FAILURE,
  ON_DOOR_SCHEDULE_CHANGE_REQUEST,
  ON_DOOR_SCHEDULE_CHANGE_SUCCESS,
  OPEN_DOOR,
  SET_MODAL_TYPE,
} from '../../actionConstants';

import apiClient from '../../apiClient';
import { history } from '../../store';
import { CONFIRM } from '../Modal/modalTypes';

export const dispatchOpenDoor = (dispatch, door) =>
  dispatch({
    type: OPEN_DOOR,
    payload: apiClient.accessPoint.openDoor(door),
    successMessage: `${door.name} successfully opened`,
  });

export const openDoor = (dispatch, door) => {
  if (!door.isUnitDoor) {
    return dispatchOpenDoor(dispatch, door);
  }
  const modalProps = {
    bodyText:
      'Opening this apartment door will trigger a notification to the resident',
    confirmText: 'Confirm',
    cancelText: 'Cancel',
    onConfirm: () => dispatchOpenDoor(dispatch, door),
  };
  return dispatch({
    type: SET_MODAL_TYPE,
    modalType: CONFIRM,
    modalProps,
  });
};

export const getAccessPoints = (dispatch, buildingId, { isExport, ...rest }) =>
  dispatch({
    type: ACCESS_POINTS_LIST_REQUESTED,
    withoutLoading: isExport,
    payload: apiClient.building
      .getAccessPoints(buildingId, { disable_pagination: true, ...rest })
      .then(
        (res) => {
          dispatch({
            type: isExport
              ? GET_ITEMS_FOR_EXPORT_SUCCESS
              : ACCESS_POINTS_LIST_SUCCEEDED,
            res,
          });
          return { data: { results: res?.data } };
        },
        (err) =>
          dispatch({
            type: ACCESS_POINTS_LIST_FAILURE,
            err,
          }),
      ),
  });

export const updateAccessPoint = (dispatch, id, accessPointId, data) =>
  dispatch({
    type: ACCESS_POINT_UPDATE_REQUESTED,
    isForm: true,
    payload: apiClient.building.updateAccessPoint(id, accessPointId, data).then(
      (res) => {
        dispatch({
          type: ACCESS_POINT_UPDATE_SUCCEEDED,
          successMessage: 'Access Point successfully updated',
          res,
        });
        history.goBack();
        return res;
      },
      (err) => {
        dispatch({
          type: ACCESS_POINT_UPDATE_FAILURE,
          err,
        });
        return err;
      },
    ),
  });

export const createAccessPoint = (dispatch, id, data) =>
  dispatch({
    type: ACCESS_POINT_CREATE_REQUESTED,
    isForm: true,
    payload: apiClient.building.createAccessPoint(id, data).then(
      (res) => {
        dispatch({
          type: ACCESS_POINT_CREATE_SUCCEEDED,
          successMessage: 'Access Point successfully created',
          res,
        });
        history.goBack();
        return res;
      },
      (err) => {
        dispatch({
          type: ACCESS_POINT_CREATE_FAILURE,
          err,
        });
        return err;
      },
    ),
  });

export const getDoors = (
  dispatch,
  params = {},
  buildingId,
  isExport,
  removePrev,
  updateDoors,
) => {
  const queryParams = { ...params, disable_pagination: true };
  return dispatch({
    type: GET_DOORS_REQUEST,
    withoutLoading: isExport,
    payload: apiClient.building.getDoors(queryParams, buildingId).then(
      (res) => {
        dispatch({
          type: isExport ? GET_ITEMS_FOR_EXPORT_SUCCESS : GET_DOORS_SUCCESS,
          removePrev,
          res,
          buildingId,
        });
        updateDoors && updateDoors(res?.data);
        return { data: { results: res?.data } };
      },
      (err) =>
        dispatch({
          type: GET_DOORS_FAILURE,
          err,
        }),
    ),
  });
};

export const getDoor = (dispatch, buildingId, doorId, removePrev) =>
  dispatch({
    type: GET_DOOR_REQUEST,
    payload: apiClient.building.getDoor(buildingId, doorId).then(
      (res) => {
        dispatch({
          type: GET_DOOR_SUCCESS,
          removePrev,
          res,
          buildingId,
        });
        return { data: { results: res?.data } };
      },
      (err) =>
        dispatch({
          type: GET_DOOR_FAILURE,
          err,
        }),
    ),
  });

const onDoorScheduleChange = (dispatch, buildingId, doorId, schedule) => {
  if (!Object.keys(schedule).length || !doorId) return null;
  return dispatch({
    type: ON_DOOR_SCHEDULE_CHANGE_REQUEST,
    isForm: true,
    payload: apiClient.building
      .createDoorSchedule(buildingId, doorId, { schedule })
      .then(
        (res) => {
          dispatch({
            type: ON_DOOR_SCHEDULE_CHANGE_SUCCESS,
            res,
          });
          return null;
        },
        (err) => {
          dispatch({
            type: ON_DOOR_SCHEDULE_CHANGE_FAILURE,
            err,
          });
          return err;
        },
      ),
  });
};

export const updateDoor = (dispatch, buildingId, doorId, data) => {
  const { schedule, ...rest } = data;
  return dispatch({
    type: DOOR_UPDATE_REQUESTED,
    isForm: true,
    payload: apiClient.building.updateDoor(buildingId, doorId, rest).then(
      async (res) => {
        const errors = await onDoorScheduleChange(
          dispatch,
          buildingId,
          doorId,
          schedule,
        );
        if (errors) return errors;
        history.goBack();
        return dispatch({
          type: DOOR_UPDATE_SUCCEEDED,
          successMessage: 'Door was successfully updated',
          res,
        });
      },
      (err) => {
        dispatch({
          type: DOOR_UPDATE_FAILURE,
          err,
        });
        return err;
      },
    ),
  });
};

export const createDoor = (dispatch, buildingId, data) => {
  const { schedule, ...rest } = data;
  return dispatch({
    type: DOOR_CREATE_REQUESTED,
    isForm: true,
    payload: apiClient.building.createDoor(buildingId, rest).then(
      async (res) => {
        const doorId = res?.data?.id;
        const errors = await onDoorScheduleChange(
          dispatch,
          buildingId,
          doorId,
          schedule,
        );
        if (errors) return errors;
        history.goBack();
        return dispatch({
          type: DOOR_CREATE_SUCCEEDED,
          successMessage: 'Door was successfully created',
          res,
        });
      },
      (err) => {
        dispatch({
          type: DOOR_CREATE_FAILURE,
          err,
        });
        return err;
      },
    ),
  });
};

export const deleteDoor = (dispatch, buildingId, doorId) =>
  dispatch({
    type: DOOR_DELETE_REQUEST,
    payload: apiClient.building.deleteDoor(buildingId, doorId).then(
      () =>
        dispatch({
          type: DOOR_DELETE_SUCCESS,
          buildingId,
          doorId,
          successMessage: 'Door successfully removed',
        }),
      (err) =>
        dispatch({
          type: DOOR_DELETE_FAILURE,
          err,
        }),
    ),
  });

export const getAccessPointDeviceModels = (dispatch) =>
  dispatch({
    type: GET_AP_DEVICE_MODELS_REQUEST,
    payload: apiClient.accessPoint.deviceModels().then(
      (res) =>
        dispatch({
          type: GET_AP_DEVICE_MODELS_SUCCESS,
          res,
        }),
      (err) =>
        dispatch({
          type: GET_AP_DEVICE_MODELS_FAILURE,
          err,
        }),
    ),
  });

export const confirmDeleteDoor = (dispatch, buildingId, doorId) => {
  const modalProps = {
    bodyText: `Are you sure?`,
    onConfirm: () => deleteDoor(dispatch, buildingId, doorId),
  };
  return dispatch({
    type: SET_MODAL_TYPE,
    modalType: CONFIRM,
    modalProps,
  });
};

export const onDoorsReorder = (dispatch, buildingId, data) => {
  const formattedData = { order: data.map((door) => door.id) };
  return dispatch({
    type: DOORS_REORDER_REQUEST,
    payload: apiClient.building.setDoorsOrder(buildingId, formattedData).then(
      () => {
        dispatch({
          type: DOORS_REORDER_SUCCESS,
          successMessage: 'Doors order changed',
        });
        return getDoors(dispatch, {}, buildingId);
      },
      (err) =>
        dispatch({
          type: DOORS_REORDER_FAILURE,
          err,
        }),
    ),
  });
};

export const PLACEHOLDER = 'PLACEHOLDER';
